import { Hammer } from 'lucide-react'
import { AxiosError } from 'axios'
import ListHeader from '@/common/components/ListHeader'
import { Mapper } from '@/common/services/mapper'
import AuctionKanbanColumn from '../../components/AuctionKanbanColumn'
import AuctionFollowingCard from '../../components/AuctionFollowingCard'
import AuctionCard from '../../components/AuctionCard'
import { AuctionCardData } from '../../types/auctionCard.type'
import { useAvailableAuctions } from '../../hooks/useAvailableAuctions'
import { useFollowingAuctions } from '../../hooks/useFollowingAuctions'
import { AuctionSummaryTransformer } from '../../services/auctionSummaryTransformer'

const isForbidden = (error: unknown) => (error as AxiosError | null)?.response?.status === 403

const MaintenanceAuctionsList = () => {
  const available = useAvailableAuctions<AuctionCardData[]>({
    mapper: Mapper.mapWithTransformer({ transformer: AuctionSummaryTransformer.mapAvailableAuctionToCard() }),
  })
  const following = useFollowingAuctions<AuctionCardData[]>({
    filters: { isCompletelyDone: false },
    mapper: Mapper.mapWithTransformer({ transformer: AuctionSummaryTransformer.mapFollowingAuctionToCard('in_dispute') }),
  })
  const closed = useFollowingAuctions<AuctionCardData[]>({
    filters: { isCompletelyDone: true },
    mapper: Mapper.mapWithTransformer({ transformer: AuctionSummaryTransformer.mapFollowingAuctionToCard('closed') }),
  })

  return (
    <div className="inner-screen gap-6 overflow-hidden">
      <ListHeader
        Icon={<Hammer className="w-10 h-10" strokeWidth={1.5} />}
        title="Leilões de manutenção"
      />

      <div className="flex gap-4 flex-1 overflow-x-auto overflow-y-hidden">
        <AuctionKanbanColumn
          title="Disponíveis"
          count={available.data.length}
          refreshSeconds={60}
          onRefresh={available.refetch}
          isLoading={available.isLoading}
          isError={available.isError}
          forbidden={isForbidden(available.error)}
        >
          {available.data.map((card) => (
            <AuctionCard key={card.id} data={card} />
          ))}
        </AuctionKanbanColumn>

        <AuctionKanbanColumn
          title="Acompanhando"
          count={following.data.length}
          className="flex-[1.7] min-w-[380px]"
          realtime
          isLoading={following.isLoading}
          isError={following.isError}
          forbidden={isForbidden(following.error)}
        >
          {following.data.map((card) => (
            <AuctionFollowingCard key={card.id} data={card} />
          ))}
        </AuctionKanbanColumn>

        <AuctionKanbanColumn
          title="Encerrados"
          count={closed.data.length}
          isLoading={closed.isLoading}
          isError={closed.isError}
          forbidden={isForbidden(closed.error)}
        >
          {closed.data.map((card) => (
            <AuctionCard key={card.id} data={card} />
          ))}
        </AuctionKanbanColumn>
      </div>
    </div>
  )
}

export default MaintenanceAuctionsList
